import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { TherapyJSONAModel } from "interfaces/jsona-models/TherapyJSONAModel";

export class TherapySelector extends BaseApiSelector<TherapyJSONAModel> {
  constructor() {
    super(ResourceType.Therapy);
  }
}
